import { render, staticRenderFns } from "./FormulateObjectArrival.vue?vue&type=template&id=e5173b70&"
import script from "./FormulateObjectArrival.vue?vue&type=script&lang=ts&"
export * from "./FormulateObjectArrival.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports